import { OPERATORS } from '../constants';

/**
 * Operators that use the single-choice preference UX (click defaults preference to 1).
 * Keep this centralized so Opportunity/Feasibility dialogs don't maintain duplicate lists.
 */
const SINGLE_PREFERENCE_OPERATORS = new Set<string>([
  OPERATORS.CAPELLA,
  OPERATORS.SATELLOGIC,
  OPERATORS.UMBRA,
  OPERATORS.BLACKSKY,
  OPERATORS.ESPER,
  OPERATORS.AZISTA,
]);

export function usesSinglePreferenceInputForOpportunity(operatorKey: string | null | undefined): boolean {
  if (!operatorKey) return false;
  return SINGLE_PREFERENCE_OPERATORS.has(operatorKey);
}

export function usesSinglePreferenceInputForFeasibility(sensorRow: any): boolean {
  const operatorKey: string | null | undefined = sensorRow?.operatorKey;
  if (!operatorKey) return false;

  if (operatorKey === OPERATORS.ECURS) {
    const sensorType = String(sensorRow?.sensortype ?? '');
    if (sensorType === 'InSAR' || sensorType === 'SAR') return true;
  }

  return SINGLE_PREFERENCE_OPERATORS.has(operatorKey);
}
